export const ticketChecklist = {
    'reproducible': 'Issue reproducible by CS',
    'steps_mentioned': 'Reproduction steps mentioned in description',
    'design_link': 'Design link. Component editor link (if applicable) and Work Order link (if applicable) mentioned',
    'design_shared': 'Design shared with pm1@infurnia.com',
    'annotation_mentioned': 'Relevant Cabinet, Panel, 3D Model annotation is mentioned (CxPy)',
    'output_name': 'Relevant output name is mentioned (e.g. Schedule) and sample output file attached',
    'none': 'None of the above are applicable',
}
